import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('setSafeSendersOption')(function setSafeSendersOption(safeSenders, state) {
    var optionState = state.optionState;
    optionState.safeSenders = safeSenders;
}));
//# sourceMappingURL=setSafeSendersOption.js.map